<template>
  <sweet-modal
    ref="modal"
    overlay-theme="dark"
    blocking
    hide-close-button
    enable-mobile-fullscreen
  >
    <div class="text-left">
      <p class="text-2xl font-bold">{{ vaultName }} Pricing</p>
      <p class="mt-4 text-sm">
        To all our StrataVault client from 31 December 2025 we will be moving to a new subscription pricing model
      </p>
      <table id="pricing-table" class="w-full text-sm mt-4">
        <thead>
          <tr>
            <th rowspan="3" colspan="2" class="pl-2">ex GST</th>
          </tr>
          <tr class="font-bold">
            <th
              class="
                text-center text-white
                bg-brand
                uppercase
                border-t border-l border-brand
              "
            >
              New Pricing
            </th>
          </tr>
        </thead>
        <tbody class="font-bold text-center border border-black">
          <tr
            v-for="(plan, index) in plans"
            :key="index"
            class="border-b"
            :class="[index % 2 == 0 ? 'border-grey' : 'border-black']"
          >
            <td class="py-1 px-2 text-left">{{ plan.name }}</td>
            <td
              class="py-1 px-2 font-semibold uppercase"
              :class="[index % 2 == 0 ? 'text-gray-dark' : 'text-brand']"
            >
              {{ plan.interval }}
            </td>
            <td
              class="py-1 bg-brand-lightest"
              :class="[index % 2 == 1 ? 'text-brand' : '']"
            >
              ${{ plan.newPrice }}
            </td>
          </tr>
        </tbody>
      </table>
      <p class="mt-4 text-sm">
        <a
          href="/2025-2026 Price-Increase-Letter.pdf"
          target="_blank"
          download
          class="text-brand underline"
          >Download</a
        >
        the {{ vaultName }} Price update notification.
      </p>
      <div
        class="
          mt-4
          bg-brand-lightest
          rounded
          p-4
          text-xs
          flex
          items-center
          justify-between
        "
      >
        <div>
          <p class="font-bold">
            I confirm my acknowledgment of the new pricing.
          </p>
          <p class="font-bold">
            If you have any questions, please
            <a
              href="mailto:team@thestratavault.com"
              class="text-brand underline"
              >contact us.</a
            >
          </p>
        </div>
        <div>
          <button
            class="
              bg-brand
              text-white
              font-bold
              px-6
              py-3
              rounded
              hover:bg-brand-dark
            "
            @click="acceptAgreement"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  </sweet-modal>
</template>

<script>
import * as Sentry from "@sentry/vue";

export default {
  name: "PriceIncrease2026",
  data() {
    return {
      plans: [
        {
          name: "Starter Vault - 1GB",
          interval: "Monthly",
          currentPrice: "16.10",
          newPrice: "17.71",
        },
        {
          name: "Starter Vault",
          interval: "Annual",
          currentPrice: "173.92",
          newPrice: "191.32",
        },
        {
          name: "Small Vault - 5GB",
          interval: "Monthly",
          currentPrice: "35.43",
          newPrice: "35.43",
        },
        {
          name: "Small Vault",
          interval: "Annual",
          currentPrice: "347.85",
          newPrice: "382.64",
        },
        {
          name: "Medium Vault - 25GB",
          interval: "Monthly",
          currentPrice: "64.42",
          newPrice: "70.86",
        },
        {
          name: "Medium Vault",
          interval: "Annual",
          currentPrice: "695.69",
          newPrice: "765.29",
        },
        {
          name: "Large Vault - 100GB",
          interval: "Monthly",
          currentPrice: "128.84",
          newPrice: "141.73",
        },
        {
          name: "Large Vault",
          interval: "Annual",
          currentPrice: "1,391.50",
          newPrice: "1,530.68",
        },
      ],
    };
  },
  mounted() {
    this.open();
  },
  methods: {
    async open() {
      if (this.vaultType != "strata") {
        return;
      }

      try {
        const response = await axios.get(
          "api/vaults/agreements/price-increase-2025"
        );
      } catch (error) {
        // if 404 open price increase modal, ignore network errors
        if (error.response?.status == 404) {
          this.$refs.modal.open();
        }
      }
    },
    async acceptAgreement() {
      try {
        const response = await axios.post(
          "api/vaults/agreements/price-increase-2025"
        );
        if (response.status == 201 && response.data.success) {
          this.$noty.success(
            "Successfully accepted price increase agreement."
          );

          this.$refs.modal.close();
        }
      } catch (error) {
        Sentry.captureException(error);

        const message =
          error.response?.data?.message ?? "Unexpected error.";
        this.$noty.error(message);
      }
    },
  },
  computed: {
    vaultType() {
      return window.vault_type;
    },
    vaultName() {
      return _.startCase(window.vault_type) + "Vault";
    },
  },
};
</script>

<style scoped>
div >>> .sweet-modal.is-visible .sweet-content {
  padding: 24px 32px !important;
}

#pricing-table {
  border-collapse: collapse;
}
</style>
